import { withStyles } from '@material-ui/core/styles';
import { MapOutlined } from '@material-ui/icons';
import supportHrefs from 'common/constants/supportHrefs';
import useHideWebWidget from 'common/hooks/useHideWebWidget';
import BatteryIcon from 'common/icons/Battery';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { Divider, Menu } from 'evee-ui-common/components/base';
import { Region } from 'evee-ui-common/enums';
import { history } from 'evee-ui-common/services';
import { getHomeUrl } from 'evee-ui-common/utils';
import useRegion from 'store/modules/app/hooks/useRegion';
import useAuth from 'store/modules/auth/hooks/useAuth';

import { Bolt, Car, File, Gift, Lightbulb, Notebooks, SignIn, UserPlus, Wallet } from '../../icons';
import Item from '../../utils/Item';
import styles from '../styles';

const MainMenu = ({ anchorEl, open, classes, onClose }) => {
  const { onSignIn, onSignUp } = useAuth();
  const { region } = useRegion();
  const location = useLocation();

  useHideWebWidget(open);

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      openDirection="bottom"
      classes={{ list: classes.container, paper: classes.paper }}
      onClose={onClose}
    >
      <Item
        bold
        label="Sign up"
        data-test-id="sign-up-button"
        icon={<UserPlus />}
        onClick={() => {
          onSignUp();
          onClose();
        }}
      />

      <Item
        label="Log in"
        data-test-id="log-in-button"
        icon={<SignIn />}
        onClick={() => {
          onSignIn();
          onClose();
        }}
      />

      <Item
        selected={location.pathname === '/car-host'}
        label="Become a host"
        icon={<Car />}
        onClick={() => {
          history.push('/car-host');
          onClose();
        }}
      />

      <Divider className={classes.divider} />

      <Item
        label="All evee vehicles"
        selected={location.pathname.includes('/vehicles') || location.pathname.includes('/search')}
        icon={<MapOutlined />}
        onClick={() => {
          history.push('/vehicles');
          onClose();
        }}
      />

      <Item
        label="How evee works"
        icon={<Lightbulb />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/renting`;
        }}
      />

      <Item
        label="Rewards program"
        icon={<Bolt />}
        onClick={() => {
          window.location.href = `${getHomeUrl(Region.australia)}/pages/rewards`;
        }}
      />

      <Item
        label="Insurance"
        icon={<File />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/insurance`;
        }}
      />

      <Item
        label="Novated leasing"
        icon={<Wallet />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/pages/novated-leasing`;
        }}
      />

      <Item
        label="Charging guide"
        icon={<BatteryIcon />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/blog/your-evee-intro-guide-to-charging`;
        }}
      />

      <Item
        label="Gift cards"
        icon={<Gift />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/giftcards`;
        }}
      />

      <Divider className={classes.divider} />

      <Item
        label="Get help"
        icon={<Notebooks />}
        onClick={() => {
          window.location.href = supportHrefs[region.id].helpCenter;
        }}
      />
    </Menu>
  );
};

MainMenu.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool,
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
    paper: PropTypes.string.isRequired,
    menuItem: PropTypes.string.isRequired,
    divider: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func,
};

MainMenu.defaultProps = {
  anchorEl: {},
  open: false,
  onClose: () => {},
};

export default withStyles(styles)(MainMenu);
